export const formatDateFromMs = (milliseconds: number) => {
  const date = new Date(milliseconds);
  const timeString = date
    .toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    })
    // https://stackoverflow.com/q/75406192
    .replace('\u202F', ' ');
  const dateString = date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
  });
  const yearString = date.getFullYear().toString();
  return `${timeString} ${dateString} ${yearString}`;
};
